import { csv } from 'd3';
import _ from 'lodash';
import { data_folder } from '../inputs/data_paths';
import { getAgeKey } from './utils.js';

const data_points_path = `${data_folder}data/combined.csv`;

const loadData = async () => {
    const data = {
        Prairies: {},
        Canada: {}
    };

    await csv(data_points_path, (d, i) => {
        // set _id attribute
        d._id = i;

        _.forEach(["n", "GeometricMean", "Median", "LowerPercentile", "UpperPercentile", "LowerPercentileType", "UpperPercentileType", "LOD", "RecLimit"], (prop) => {
            d[prop] = parseFloat(d[prop]);
        });

        // if LowerPercentile or UpperPercentile is invalid, nullify the other
        if(_.isNaN(d.LowerPercentile) || _.isNaN(d.UpperPercentile)) {
            d.LowerPercentile = null;
            d.UpperPercentile = null;
        }

        // add data point to group
        if(d.Cycle === "1-5") {
            // if cycle === "1-5", set it to active which means it gets shown for all cycles
            _.setWith(data, [d.Region, d.ChemicalGroup, d.ChemicalSubstances, d.Matrix, 'active', getAgeKey(d)], {
                ...d,
                Cycle: 'active'
            }, Object);
        } else {
            _.setWith(data, [d.Region, d.ChemicalGroup, d.ChemicalSubstances, d.Matrix, d.Cycle, getAgeKey(d)], d, Object);
        }
    });

    return data;
};

export default loadData;